import {UIController} from "../UIController";

/******************************************************************
 * NewsletterSignupButtonController
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class NewsletterSignupButtonController extends UIController {

    /******************************************************************
     * Properties
     *****************************************************************/

    private readonly _dialog: HTMLDialogElement

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor(rootElement: HTMLElement) {
        super(rootElement);
        this._dialog = document.getElementById("kkt-newsletter-signup-modal") as HTMLDialogElement;
        this.initListeners()
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private initListeners(): void {
        this.view.addEventListener("click", () => {
            this._dialog.showModal();
        });
    }

}
